<template>
  <div class="task-fields">
      <draggable v-model="taskOrder" @update="taskSortHandler" :disabled="false">
        <div :class="getClassForTaskField(task)" class="d-flex flex-row field-block" v-for="(task, index) in tasks" :key="'task'+index">
          <div class="field-control-wrapper field-control-wrapper__title" :class="{'no-radius': (index != tasks.length-1)}">
            <TaskTitle :fullDeliverables="fullDeliverables" :deliverableId="deliverableId" :deliverable="deliverable" :totalTasks="tasks.length" :task="task" :index="index" @toggleTaskFields="showTaskFields" :namespace="namespace"/>
          </div>
          <div
            class="d-none d-lg-block field-rows"
            :class="getClasses(taskField)+' toggleTaskField__'+task.id"
            v-for="(taskField, index1) in task.taskFields"
            :key="'taskField'+index1"
          >
            <CustomFields 
            :fullDeliverables="fullDeliverables" 
            :sortEnabledFields="['status', 'status_note', 'user', 'due_date', 'request']" 
            :taskCount="tasks.length" 
            :multipleTasks="index == 0" 
            :deliverable="deliverable" 
            :users="users" 
            :customField="taskField" 
            :rows="1" 
            :namespace="namespace" 
            :task="task"
            :isTaskAssignedToLoggedInUser="isTaskAssignedToLoggedInUser(task)"
            :disabled="taskField.field_type == 'datepicker' ? true : false"
            ></CustomFields>
          </div>
        </div>
        <AdditionalFields :deliverableType="deliverable.deliverable_template_id" :deliverableId="deliverableId"  :namespace="namespace"/>
      </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import CustomFields from "./CustomField";
import TaskTitle from "./TaskTitle";
import AdditionalFields from "../common/AdditionalFields";
import { mapActions, mapState } from "vuex";

export default {
  props: ["tasks", "users", "deliverableId", "myWeek", "deliverable", "fullDeliverables", "namespace"],
  data() {
    return {
      showAdditionalFields: false
    }
  },
  components: {
    draggable,
    CustomFields,
    TaskTitle,
    AdditionalFields
  },
  computed: {
  	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  taskHighlighted (state, getters) {
  	    return getters[this.namespace + 'taskHighlighted']
  	  },
  	  tasksToHighlight (state, getters) {
  	    return getters[this.namespace + 'tasksToHighlight']
  	  },
  	  deliverableFilter (state, getters) {
  	    return getters[this.namespace + 'deliverableFilter']
  	  },
      deliverableTemplateFilter (state, getters) {
        return getters[this.namespace + 'deliverableTemplateFilter']
      },
  	  myWeekDeliverableFilter (state, getters) {
  	    return getters[this.namespace + 'myWeekDeliverableFilter']
  	  },
  	  projectDeliverableListFilter (state, getters) {
  	    return getters[this.namespace + 'projectDeliverableListFilter']
  	  },
  	  storedSortKey (state, getters) {
  	    return getters[this.namespace + 'storedSortKey']
  	  },
  	  storedSortState (state, getters) {
  	    return getters[this.namespace + 'storedSortState']
  	  },
  	  nextSortState (state, getters) {
  	    return getters[this.namespace + 'nextSortState']
  	  },
  	  storedSortFieldId (state, getters) {
  	    return getters[this.namespace + 'storedSortFieldId']
  	  },
  	}),
    taskOrder: {
      get: function() {
        return this.deliverable.tasks
      },
      set: function(newValue) {
        this.deliverable.tasks = newValue
      }
    }
  },
  methods: {
    ...mapActions({
      updateFieldValue (dispatch, payload) {
        return dispatch(this.namespace + 'updateFieldValue', payload)
      },
    }),
    taskSortHandler() {
      // localStorage.setItem('storedSortKey', 'created_date')
      // localStorage.setItem('storedSortState', 'ASC')
      // localStorage.setItem('nextSortState', 'DESC')
      // localStorage.setItem('storedSortFieldId', null)
      // this.storedSortKey = 'created_date'
      // this.storedSortState = 'ASC'
      // this.nextSortState = 'DESC'
      // this.storedSortFieldId = null
      // this.$store.commit('updateReorderedTasks', {taskData: this.taskOrder, deliverableId: this.deliverableId})
      this.$store.dispatch(this.namespace + 'saveTaskOrder', {taskData: this.taskOrder, deliverableTemplateId: this.deliverableId})
    },

    showTaskFields(taskId) {
      if($('.toggleTaskField__'+taskId).hasClass('d-none')) {
        $('.toggleTaskField__'+taskId).removeClass('d-none');
      } else {
        $('.toggleTaskField__'+taskId).addClass('d-none');
      }
    },

    getClasses(task) {
      let classes = "field-control-wrapper";
      if (task) {
        classes += " field-control-wrapper__"+task.field_key;
      }
      return classes;
    },
    isTaskAssignedToLoggedInUser(task) {
      if (task.taskFields) {
        const taskFields = task.taskFields;
        const userField = _.find(taskFields, { field_key: 'user' });
        if (userField && userField.value == localStorage.getItem('userId')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkUser(taskFields) {
      if (!this.myWeek) return "";
      if (taskFields) {
        const userField = _.find(taskFields, { field_key: 'user' });
        if (userField && userField.value != localStorage.getItem('userId')) {
          return "diff-user";
        }
      }
    },
    getClassForTaskField(task) {
      const isHighlighted = this.tasksToHighlight.includes(task.id) ? 'highlight' : '';
      let isHighlight = task.id == this.taskHighlighted ? 'highlight' : '';
      let isUserHighlight = this.isUserSelected(task) ? 'user-highlight' : ''
      return this.checkUser(task.taskFields) + ' ' + isHighlight + ' ' + isUserHighlight + ' ' + isHighlighted;
    },

    isUserSelected(task) {
      let filterUsed = null;
      if (this.myWeek) {
        filterUsed = this.myWeekDeliverableFilter;
      } else if (this.$router.currentRoute.name == 'projectDeliverable') {
        filterUsed = this.projectDeliverableListFilter;
      } else if (this.$router.currentRoute.name == 'deliverable-templates') {
        filterUsed = this.deliverableTemplateFilter;
      } else {
        filterUsed = this.deliverableFilter;
      }
      if (!filterUsed || !Array.isArray(filterUsed.coordinator) || !Array.isArray(task.taskFields) || !task.taskFields.length) {
        return false;
      }

        const userField = _.find(task.taskFields, { field_key: 'user' });
      const taskUserValue = userField ? userField.value : null;
      if (!taskUserValue) return false;

          let isSame = false;
          filterUsed.coordinator.forEach(x => {
              if (x.id == taskUserValue) isSame = true;
      });
            return isSame;
          }
  },
};
</script>

<style>
</style>
